module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-18.0905d588.png";